// src/socket.js
import { io } from "socket.io-client";

// Use environment variable for flexibility
const API_URL = process.env.REACT_APP_API_URL || "https://api.bookyourneed.com";

const socket = io(API_URL, {
  withCredentials: true,
  autoConnect: true, // connect when app mounts
  transports: ["websocket"],
  path: "/socket.io",
  secure: true, // important for https
});

// ✅ Helpful logs
socket.on("connect_error", (err) => {
  console.error("⚠️ socket connect_error:", err.message);
});

socket.on("connect", () => {
  console.log("✅ socket connected:", socket.id);
});

export default socket;

